import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { QuestionFacade } from '../facade/question.facade';
import { ResolutionContext } from '../resolver/result-page.resolver';
import { RedirectToBeginning, SIMULATION_LOAD_RULES } from '../resolver/simulation-load.rules';

export const ResultPageGuard = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const facade = inject(QuestionFacade);
  const router = inject(Router);

  const ctx: ResolutionContext = {
    facade,
    router,
    stateSnapshot: facade.state$.value,
    queryParams: route.queryParams,
  };

  const rule = SIMULATION_LOAD_RULES.find((rule) => rule.canHandle(ctx));
  if (!rule) {
    return false;
  }

  if (rule instanceof RedirectToBeginning) {
    return rule.urlToAppStart(router, route.queryParams, facade.state$.value.type);
  }
  return true;
};
